import request from "../utils/request"

export function fetchDesignProjects(params) {
  return request({ url: "/office/design/projects", method: "get", params })
}

export function fetchStartupImageConfig() {
  return request({ url: "/office/design/startup/config", method: "get" })
}

export function saveStartupImageConfig(data) {
  return request({ url: "/office/design/startup/config", method: "put", data })
}

export function fetchDesignCompanies() {
  return request({ url: "/office/design/companies", method: "get" })
}

export function createDesignCompany(data) {
  return request({ url: "/office/design/companies", method: "post", data })
}

export function updateDesignCompany(companyId, data) {
  return request({ url: `/office/design/companies/${companyId}`, method: "put", data })
}

export function fetchCompanyWorkspace(companyId) {
  return request({ url: `/office/design/companies/${companyId}/workspace`, method: "get" })
}

export function uploadCompanyResources(companyId, files, resourceCategory, onUploadProgress) {
  const data = new FormData()
  files.forEach(file => data.append("files", file))
  return request({
    url: `/office/design/companies/${companyId}/resources/upload`,
    method: "post",
    params: { resourceCategory },
    data,
    timeout: 600000,
    onUploadProgress
  })
}

export function createCompanyVersion(companyId, data) {
  return request({ url: `/office/design/companies/${companyId}/versions`, method: "post", data })
}

export function fetchDesignThemes(params) {
  return request({ url: "/office/design/themes", method: "get", params })
}

export function fetchDesignWorkspace(projectId) {
  return request({ url: `/office/design/projects/${projectId}`, method: "get" })
}

export function createDesignProject(data) {
  return request({ url: "/office/design/projects", method: "post", data })
}

export function updateDesignProject(projectId, data) {
  return request({ url: `/office/design/projects/${projectId}`, method: "put", data })
}

export function uploadDesignScreens(projectId, files, onUploadProgress) {
  const data = new FormData()
  files.forEach(file => data.append("files", file))
  return request({
    url: `/office/design/projects/${projectId}/screens/upload`,
    method: "post",
    data,
    timeout: 120000,
    onUploadProgress
  })
}

export function updateDesignScreen(screenId, data) {
  return request({ url: `/office/design/screens/${screenId}`, method: "put", data })
}

export function setDesignScreenCompleted(screenId, completed) {
  return request({ url: `/office/design/screens/${screenId}/completion`, method: "patch", data: { completed } })
}

export function deleteDesignScreen(screenId) {
  return request({ url: `/office/design/screens/${screenId}`, method: "delete" })
}

export function uploadDesignAssets(projectId, screenId, files, onUploadProgress) {
  const data = new FormData()
  files.forEach(file => data.append("files", file))
  return request({
    url: `/office/design/projects/${projectId}/assets/upload`,
    method: "post",
    params: { screenId },
    data,
    timeout: 180000,
    onUploadProgress
  })
}

export function deleteDesignAsset(assetId) {
  return request({ url: `/office/design/assets/${assetId}`, method: "delete" })
}

export function uploadDesignResources(projectId, files, resourceCategory, onUploadProgress) {
  const data = new FormData()
  files.forEach(file => data.append("files", file))
  return request({
    url: `/office/design/projects/${projectId}/resources/upload`,
    method: "post",
    params: { resourceCategory },
    data,
    timeout: 600000,
    onUploadProgress
  })
}

export function fetchDesignVersions(projectId) {
  return request({ url: `/office/design/projects/${projectId}/versions`, method: "get" })
}

export function createDesignVersion(projectId, data) {
  return request({ url: `/office/design/projects/${projectId}/versions`, method: "post", data })
}

export function updateDesignVersion(versionId, data) {
  return request({ url: `/office/design/versions/${versionId}`, method: "put", data })
}

export function deleteDesignVersion(versionId) {
  return request({ url: `/office/design/versions/${versionId}`, method: "delete" })
}
